import {accountHasFeature} from 'helpers/user'
import {features} from 'helpers/constants'

export const vatRate = 0.2

export const getYearlySaving = (monthlyPrice, yearlyPrice) => {
  return (monthlyPrice * 12) - yearlyPrice
}

export const isComplexPricingEnabled = (user) => {
  return accountHasFeature(user, features.COMPLEX_PRICING)
}
